import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/illus-home.png'


const _hoisted_1 = {
  key: 0,
  class: "p-10"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "sm:flex-grow bg-background h-full py-8 min-h-screen relative" }
const _hoisted_4 = {
  key: 0,
  class: "py-4 justify-between container items-start h-full"
}
const _hoisted_5 = {
  key: 0,
  class: "bg-white rounded-2xl shadow lg:p-8 p-3"
}
const _hoisted_6 = { class: "pt-4" }
const _hoisted_7 = { class: "flex flex-col lg:flex-row justify-center items-center lg:items-start lg:justify-start" }
const _hoisted_8 = { class: "flex flex-row justify-center items-center rounded-full bg-primary text-white text-4xl w-24 h-24 p-4" }
const _hoisted_9 = { class: "block px-4 w-full items-center lg:items-start justify-center lg:justify-start mt-2 lg:mt-0" }
const _hoisted_10 = { class: "flex flex-row lg:justify-between w-full items-center lg:items-start justify-center text-center" }
const _hoisted_11 = { class: "block text-base lg:text-2xl font-bold" }
const _hoisted_12 = { class: "flex items-center justify-between relative" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "flex flex-col mb-4 text-base text-gray-400 justify-center lg:justify-start items-center lg:items-start mt-2 lg:mt-0" }
const _hoisted_15 = { class: "block" }
const _hoisted_16 = { class: "block" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Salary expectation: ")
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = { class: "block" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Current salary: ")
const _hoisted_21 = { class: "font-medium" }
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Preferred work type: ")
const _hoisted_24 = { class: "ml-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-black font-semibold mt-8" }, "Contact info", -1)
const _hoisted_26 = { class: "px-4 mt-3 mb-4 w-full flex flex-col space-y-2" }
const _hoisted_27 = { class: "flex flex-col lg:flex-row" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"flex lg:w-44\"><svg class=\"h-5 w-5 text-gray-500\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"></path><polyline points=\"22,6 12,13 2,6\"></polyline></svg><span class=\"text-sm text-gray-400 ml-4\">Personal email:</span></div>", 1)
const _hoisted_29 = { class: "flex ml-8 lg:ml-0" }
const _hoisted_30 = { class: "text-sm text-purple-500 ml-1" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "flex flex-col lg:flex-row" }
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"flex lg:w-44\"><svg class=\"h-5 w-5 text-gray-500\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z\"></path><circle cx=\"12\" cy=\"10\" r=\"3\"></circle></svg><span class=\"text-sm text-gray-400 ml-4\">Address:</span></div>", 1)
const _hoisted_34 = { class: "flex ml-8 lg:ml-0" }
const _hoisted_35 = { class: "text-sm text-gray-500 ml-1" }
const _hoisted_36 = { class: "flex flex-col lg:flex-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex lg:w-44" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-500",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400 ml-4" }, "Phone:")
], -1)
const _hoisted_38 = { class: "flex ml-8 lg:ml-0" }
const _hoisted_39 = { class: "text-sm text-gray-500 ml-1" }
const _hoisted_40 = { class: "flex flex-col lg:flex-row" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"flex lg:w-44\"><svg class=\"h-5 w-5 text-gray-500\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\"></path><path d=\"M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5\"></path><path d=\"M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5\"></path><line x1=\"16\" y1=\"21\" x2=\"16\" y2=\"19\"></line><line x1=\"19\" y1=\"16\" x2=\"21\" y2=\"16\"></line><line x1=\"3\" y1=\"8\" x2=\"5\" y2=\"8\"></line><line x1=\"8\" y1=\"3\" x2=\"8\" y2=\"5\"></line></svg><span class=\"text-sm text-gray-400 ml-4\">Link:</span></div>", 1)
const _hoisted_42 = { class: "flex ml-8 lg:ml-0" }
const _hoisted_43 = {
  key: 0,
  class: "text-base text-black font-semibold flex flex-row items-center my-4"
}
const _hoisted_44 = {
  key: 1,
  class: "mt-1 text-sm rounded-lg p-2 text-purple-700 my-4"
}
const _hoisted_45 = {
  key: 2,
  class: "w-full"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "block text-base font-semibold" }, " Summary ", -1)
const _hoisted_47 = { class: "text-sm text-gray-500" }
const _hoisted_48 = { class: "space-y-3 p-3 w-full" }
const _hoisted_49 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "flex flex-row justify-between" }
const _hoisted_52 = { class: "w-1/6 flex items-start" }
const _hoisted_53 = { class: "text-gray-500 font-thin" }
const _hoisted_54 = { class: "w-5/6 flex flex-col" }
const _hoisted_55 = { class: "text-base font-semibold" }
const _hoisted_56 = { class: "text-sm" }
const _hoisted_57 = { class: "text-sm text-gray-400" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "flex flex-row justify-between" }
const _hoisted_62 = { class: "w-1/6 flex items-start" }
const _hoisted_63 = { class: "w-5/6 flex flex-col" }
const _hoisted_64 = { class: "text-base font-semibold" }
const _hoisted_65 = { class: "text-sm" }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "flex flex-row w-full" }
const _hoisted_70 = { class: "ml-4 flex flex-row justify-between w-full" }
const _hoisted_71 = { class: "flex flex-col w-2/3" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "text-xs text-gray-400" }
const _hoisted_74 = { class: "text-xs text-gray-400 capitalize" }
const _hoisted_75 = { class: "flex flex-row justify-end w-1/3" }
const _hoisted_76 = { class: "font-thin text-gray-400 text-xs" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode("Applied on • ")
const _hoisted_78 = { key: 1 }
const _hoisted_79 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_80 = { class: "" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 mb-2 mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-2xl" }, "Resume")
], -1)
const _hoisted_83 = { class: "flex justify-end w-full mt-5" }
const _hoisted_84 = ["href"]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
  })
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "pl-1" }, "Download", -1)
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = { key: 1 }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 py-8 flex flex-col justify-center items-center bg-gray-100 rounded-lg shadow-lg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-24"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-base font-thin pt-5 text-primary" }, "You have not uploaded cv yet.")
], -1)
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "mt-8" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "border-b-2 mb-2 mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-2xl" }, "Other document")
], -1)
const _hoisted_94 = {
  key: 4,
  class: "flex flex-col"
}
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { key: 1 }
const _hoisted_97 = {
  key: 1,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_MenuCandidate = _resolveComponent("MenuCandidate")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_PdfView = _resolveComponent("PdfView")!
  const _component_EvaluationsAnswer = _resolveComponent("EvaluationsAnswer")!
  const _component_CandidateForm = _resolveComponent("CandidateForm")!
  const _component_AddCandidateInJob = _resolveComponent("AddCandidateInJob")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_FilesForm = _resolveComponent("FilesForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loading, {
            active: _ctx.isLoading,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
            "can-cancel": false,
            loader: "spinner",
            color: "#8908F9",
            width: 128,
            height: 128,
            opacity: 0.8,
            "is-full-page": true
          }, null, 8, ["active", "opacity"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.isLoading && _ctx.candidate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (!_ctx.editCandidate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getInitials(
                    `${_ctx.candidate?.first_name} ${_ctx.candidate?.last_name}`
                  )), 1),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(`${_ctx.candidate?.first_name} ${_ctx.candidate?.last_name}`), 1),
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_MenuCandidate, {
                                      onOpenEdit: _ctx.openEdit,
                                      onDeleteCandidate: _ctx.deleteCandidate,
                                      onAssignJob: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setShowModal(!_ctx.showModal))),
                                      candidateId: _ctx.idCandidate
                                    }, null, 8, ["onOpenEdit", "onDeleteCandidate", "candidateId"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.candidate?.position), 1),
                                _createElementVNode("span", _hoisted_16, [
                                  _hoisted_17,
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.candidate && _ctx.candidate.salary_expectation
                          ? _ctx.getSalary(
                              _ctx.candidate.show_monthly_salaries
                                ? _ctx.candidate.salary_expectation.to_show
                                : _ctx.candidate.salary_expectation.annual,
                              _ctx.candidate.salary_currency,
                              _ctx.candidate.show_monthly_salaries
                            )
                          : "N/A"), 1)
                                ]),
                                _createElementVNode("span", _hoisted_19, [
                                  _hoisted_20,
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.candidate && _ctx.candidate.current_salary
                          ? _ctx.getSalary(
                              _ctx.candidate.show_monthly_salaries
                                ? _ctx.candidate.current_salary.to_show
                                : _ctx.candidate.current_salary.annual,
                              _ctx.candidate.salary_currency,
                              _ctx.candidate.show_monthly_salaries
                            )
                          : "N/A"), 1)
                                ]),
                                _createElementVNode("span", _hoisted_22, [
                                  _hoisted_23,
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.getPreferredWork()), 1)
                                ])
                              ]),
                              _hoisted_25,
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _hoisted_28,
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("span", _hoisted_30, [
                                      _createElementVNode("a", {
                                        href: `mailto:${_ctx.candidate.email}`
                                      }, _toDisplayString(_ctx.candidate.email), 9, _hoisted_31)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _hoisted_33,
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.candidate.candidate_location
                          ? _ctx.candidate.candidate_location?.location
                              .street_address
                          : "No address"), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _hoisted_37,
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.candidate.phone ? _ctx.candidate.phone : "No phone number"), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _hoisted_41,
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["text-sm text-gray-500 ml-1", [_ctx.candidate.link ? 'text-primary' : '']])
                                    }, _toDisplayString(_ctx.candidate.link ? _ctx.candidate.link : "No link added"), 3)
                                  ])
                                ])
                              ]),
                              (
                    _ctx.candidate && _ctx.candidate.skills && _ctx.candidate.skills.length > 0
                  )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                    (_ctx.candidate && _ctx.candidate.skills.length > 0)
                                      ? (_openBlock(), _createBlock(_component_Chips, {
                                          key: 0,
                                          chips: _ctx.candidate.skills,
                                          isInput: false
                                        }, null, 8, ["chips"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_44, " No skills added ")),
                              (_ctx.candidate.summary)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _hoisted_46,
                                    _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.candidate.summary), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_Tabs, {
                            elements: _ctx.tabElements,
                            modelValue: _ctx.tab,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event))
                          }, null, 8, ["elements", "modelValue"]),
                          (_ctx.tab === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                (_ctx.candidate.candidate_work_histories.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidate.candidate_work_histories, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: `item-work-${index + 1}`,
                                          class: "w-full flex flex-col"
                                        }, [
                                          _createVNode(_component_Divider),
                                          _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                              _createElementVNode("span", _hoisted_53, _toDisplayString(`${new Date(
                          item.start_date
                        ).getFullYear()} - ${_ctx.buildNow(
                          new Date(item.end_date).getFullYear(),
                          item.is_current
                        )}`), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_54, [
                                              _createElementVNode("span", _hoisted_55, _toDisplayString(item.job_title), 1),
                                              _createElementVNode("span", _hoisted_56, _toDisplayString(item.company_name), 1),
                                              _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.buildOverYears(
                          new Date(item.start_date),
                          new Date(item.end_date),
                          item.is_current
                        )), 1)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _createVNode(_component_EmptyState, { message: "No work history found" })
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.tab === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                (_ctx.candidate.candidate_education_histories.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidate.candidate_education_histories, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: `item-work-${index + 1}`,
                                          class: "w-full flex flex-col"
                                        }, [
                                          _createVNode(_component_Divider),
                                          _createElementVNode("div", _hoisted_61, [
                                            _createElementVNode("div", _hoisted_62, [
                                              _createElementVNode("span", null, _toDisplayString(`${new Date(
                          item.start_date
                        ).getFullYear()} - ${_ctx.buildNow(
                          new Date(item.end_date).getFullYear(),
                          item.is_current
                        )}`), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_63, [
                                              _createElementVNode("span", _hoisted_64, _toDisplayString(item.degree), 1),
                                              _createElementVNode("span", _hoisted_65, _toDisplayString(item.learning_center), 1)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                      _createVNode(_component_EmptyState, { message: "No education history found" })
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.tab === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                (_ctx.candidate.job_candidates.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                      _createVNode(_component_Divider, { class: "m-3" }),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidate.job_candidates, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "flex flex-col w-full mb-4 p-4 rounded-lg shadow",
                                          key: `item-work-${index + 1}`
                                        }, [
                                          _createElementVNode("div", _hoisted_69, [
                                            _createVNode(_component_Avatar, {
                                              name: `${item.job.title}`,
                                              size: "m"
                                            }, null, 8, ["name"]),
                                            _createElementVNode("div", _hoisted_70, [
                                              _createElementVNode("div", _hoisted_71, [
                                                _createElementVNode("span", {
                                                  class: "font-semibold hover:text-primary cursor-pointer",
                                                  onClick: ($event: any) => (
                            _ctx.router.push(
                              `/jobs/${item.job.id}/job-candidates/${item.id}`
                            )
                          )
                                                }, _toDisplayString(item.job.title), 9, _hoisted_72),
                                                _createElementVNode("span", _hoisted_73, " $" + _toDisplayString(_ctx.numberWithCommas(
                              parseFloat(
                                item.job.show_monthly_salary
                                  ? item?.job.salary_min.to_show
                                  : item?.job.salary_min.annual || 0
                              )
                            )) + " - $" + _toDisplayString(_ctx.numberWithCommas(
                              parseFloat(
                                item.job.show_monthly_salary
                                  ? item?.job.salary_max.to_show
                                  : item?.job.salary_max.annual || 0
                              )
                            )) + " (" + _toDisplayString(item.job.currency_salary) + ") " + _toDisplayString(item.job.show_monthly_salary ? "Monthly" : "Annual"), 1),
                                                _createElementVNode("span", _hoisted_74, _toDisplayString(item.job.department
                              ? item.job.department
                              : "Department not specified") + " • " + _toDisplayString(item.job.company_name), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_75, [
                                                _createElementVNode("span", _hoisted_76, [
                                                  _hoisted_77,
                                                  _createVNode(_component_DateFormatter, {
                                                    date: item.applied_on
                                                  }, null, 8, ["date"])
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                      _createVNode(_component_EmptyState, { message: "No recruitment process" })
                                    ]))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.tab === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _createElementVNode("div", _hoisted_80, [
                                  (_ctx.candidate?.resume?.url)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                        _hoisted_82,
                                        _createElementVNode("div", _hoisted_83, [
                                          _createElementVNode("a", {
                                            href: _ctx.candidate?.resume?.url,
                                            target: "_blank",
                                            download: "",
                                            class: "px-4 py-2 text-primary hover:bg-primary hover:text-white text-lg rounded-full border-2 border-primary flex items-center flex-row cursor-pointer"
                                          }, _hoisted_87, 8, _hoisted_84)
                                        ]),
                                        (_openBlock(), _createBlock(_component_PdfView, {
                                          key: undefined,
                                          file: _ctx.candidate.resume?.url
                                        }, null, 8, ["file"]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_88, _hoisted_90))
                                ]),
                                _createElementVNode("div", _hoisted_91, [
                                  (_ctx.candidate?.documents?.url)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                        _hoisted_93,
                                        (_openBlock(), _createBlock(_component_PdfView, {
                                          key: undefined,
                                          file: _ctx.candidate.documents?.url
                                        }, null, 8, ["file"]))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.tab === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                (
                  _ctx.candidate.latest_evaluation_answered
                    ?.latest_evaluation_answered
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                      _createVNode(_component_EvaluationsAnswer, {
                                        evaluation: 
                    _ctx.candidate.latest_evaluation_answered
                      .latest_evaluation_answered
                  
                                      }, null, 8, ["evaluation"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                      _createVNode(_component_EmptyState, { message: "No evaluation added" })
                                    ]))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _createVNode(_component_CandidateForm, {
                          typeForm: "editCandidate",
                          candidateInfo: _ctx.candidate,
                          saveCandidate: _ctx.saveCandidate,
                          onOnValidForm: _ctx.onValidForm,
                          onOnError: _ctx.onError,
                          onIsLoadingAction: _ctx.isLoadingAction,
                          onOnShowInfo: _ctx.onShowInfo
                        }, null, 8, ["candidateInfo", "saveCandidate", "onOnValidForm", "onOnError", "onIsLoadingAction", "onOnShowInfo"])
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_ReusableModal, {
            show: _ctx.showModal,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowModal(false))),
            size: "w-4/12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AddCandidateInJob, {
                onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setShowModal(false))),
                onReloadCandidate: _ctx.getCandidate
              }, null, 8, ["onReloadCandidate"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_ReusableModal, {
            show: _ctx.showModalFile,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModalFile = false)),
            size: "w-1/2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FilesForm, {
                onCloseInForm: _ctx.closeFileForm,
                candidateId: _ctx.candidate.id
              }, null, 8, ["onCloseInForm", "candidateId"])
            ]),
            _: 1
          }, 8, ["show"])
        ]))
  ], 64))
}